import WeatherModule from './weather/module';
import BusinessCardModule from './business_card/module';

export const registeredModules = [
    WeatherModule,
    BusinessCardModule
];
